//add setting action
export const getSetting= (data)=>{
    return{
        type: 'GETSETTING',
        data
    }
}
